<template>
    <Chart  @getData='getData'>
        <template #v>
            <div id="echart_three_three"></div>
        </template>
    </Chart>
</template>

<script>
import Chart from "../components/chart";
export default {
    name: "",
    data() {
        return {

        };
    },
    methods: {
        getData(plan,echarts,times) {
            let { axis,grid,title,legend } = plan

            let option = {
                color: ['#029cda','#1cc0b7','#b5b553'],
                title: {
                    text: "城镇人均可支配收入",
                    ...title,
                },
                legend: {
                    ...legend,
                    data: [],
                    right: "center",
                    top: 20,
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: "shadow",
                    },
                },
                grid,
                xAxis: {
                    name: "年",
                    type: "category",
                    data: [],
                    ...axis,
                },
                yAxis: {
                    name: "",
                    ...axis,
                },
                series: [],
            };
            var url =
                this.urlobj.dx_jjfxty +
                `?tableName=rlt_40year_item_value&times=${times}&itemid=34`;
            this.$get(url).then((res) => {
                let data = res.rows[0].data;
                option.yAxis.name = data[0].dataArr[0].units

                let x = data[0].dataArr.map((item) => item.name);
                // option.legend.data = x;
                option.series = x.map((item) => {
                    return {
                        name: item,
                        data: [],
                        type: "line",
                        symbol: "none",
                        areaStyle: {
                            color: '#2864ac'
                        }
                    };
                });
                let arr = [];
                data.forEach((item) => {
                    option.xAxis.data.push(item.time);
                    let obj = {};
                    item.dataArr.forEach((itemx) => {
                        obj[itemx.name] = itemx.value;
                    });
                    arr.push(obj);
                });
                option.series.forEach((item) => {
                    arr.forEach((itemx) => {
                        item.data.push(itemx[item.name]);
                        //显示后5年的
                        item.data = item.data.slice(-5)
                    });
                });
                option.xAxis.data = option.xAxis.data.slice(-5)
                var myChart = echarts.init(
                    document.getElementById("echart_three_three")
                );

                myChart.setOption(option);

                
            });
        },
    },
    created() {

    },
    components: {
        Chart,
    },
};
</script>

<style lang="less" scoped>
#echart_three_three {
    height:250px
}
</style>
